/* FACILITY */

export const CURRENT_FACILITY = "CURRENT_FACILITY";

export const ADD_FACILITY = "ADD_FACILITY";
export const ADD_FACILITY_SUCCESS = "ADD_FACILITY_SUCCESS";
export const ADD_FACILITY_ERROR = "ADD_FACILITY_ERROR";

export const EDIT_FACILITY = "EDIT_FACILITY";
export const EDIT_FACILITY_SUCCESS = "EDIT_FACILITY_SUCCESS";
export const EDIT_FACILITY_ERROR = "EDIT_FACILITY_ERROR";

export const GET_FACILITY = "GET_FACILITY";
export const GET_FACILITY_SUCCESS = "GET_FACILITY_SUCCESS";
export const GET_FACILITY_ERROR = "GET_FACILITY_ERROR";

export const DELETE_FACILITY = "DELETE_FACILITY";
export const DELETE_FACILITY_SUCCESS = "DELETE_FACILITY_SUCCESS";
export const DELETE_FACILITY_ERROR = "DELETE_FACILITY_ERROR";

export const ADD_FLOOR = "ADD_FLOOR";
export const ADD_FLOOR_SUCCESS = "ADD_FLOOR_SUCCESS";
export const ADD_FLOOR_ERROR = "ADD_FLOOR_ERROR";

export const EDIT_FLOOR = "EDIT_FLOOR";
export const EDIT_FLOOR_SUCCESS = "EDIT_FLOOR_SUCCESS";
export const EDIT_FLOOR_ERROR = "EDIT_FLOOR_ERROR";

export const DELETE_FLOOR = "DELETE_FLOOR";
export const DELETE_FLOOR_SUCCESS = "DELETE_FLOOR_SUCCESS";
export const DELETE_FLOOR_ERROR = "DELETE_FLOOR_ERROR";

export const GET_FLOOR = "GET_FLOOR";
export const GET_FLOOR_SUCCESS = "GET_FLOOR_SUCCESS";
export const GET_FLOOR_ERROR = "GET_FLOOR_ERROR";

export const ADD_SECTOR = "ADD_SECTOR";
export const ADD_SECTOR_SUCCESS = "ADD_SECTOR_SUCCESS";
export const ADD_SECTOR_ERROR = "ADD_SECTOR_ERROR";

export const EDIT_SECTOR = "EDIT_SECTOR";
export const EDIT_SECTOR_SUCCESS = "EDIT_SECTOR_SUCCESS";
export const EDIT_SECTOR_ERROR = "EDIT_SECTOR_ERROR";

export const DELETE_SECTOR = "DELETE_SECTOR";
export const DELETE_SECTOR_SUCCESS = "DELETE_SECTOR_SUCCESS";
export const DELETE_SECTOR_ERROR = "DELETE_SECTOR_ERROR";

export const GET_SECTOR = "GET_SECTOR";
export const GET_SECTOR_SUCCESS = "GET_SECTOR_SUCCESS";
export const GET_SECTOR_ERROR = "GET_SECTOR_ERROR";

export const ADD_SHIFT = "ADD_SHIFT";
export const ADD_SHIFT_SUCCESS = "ADD_SHIFT_SUCCESS";
export const ADD_SHIFT_ERROR = "ADD_SHIFT_ERROR";

export const EDIT_SHIFT = "EDIT_SHIFT";
export const EDIT_SHIFT_SUCCESS = "EDIT_SHIFT_SUCCESS";
export const EDIT_SHIFT_ERROR = "EDIT_SHIFT_ERROR";

export const DELETE_SHIFT = "DELETE_SHIFT";
export const DELETE_SHIFT_SUCCESS = "DELETE_SHIFT_SUCCESS";
export const DELETE_SHIFT_ERROR = "DELETE_SHIFT_ERROR";

export const ADD_EMPLOYEE_POLICY = "ADD_EMPLOYEE_POLICY";
export const ADD_EMPLOYEE_POLICY_SUCCESS = "ADD_EMPLOYEE_POLICY_SUCCESS";
export const ADD_EMPLOYEE_POLICY_ERROR = "ADD_EMPLOYEE_POLICY_ERROR";

export const EDIT_EMPLOYEE_POLICY = "EDIT_EMPLOYEE_POLICY";
export const EDIT_EMPLOYEE_POLICY_SUCCESS = "EDIT_EMPLOYEE_POLICY_SUCCESS";
export const EDIT_EMPLOYEE_POLICY_ERROR = "EDIT_EMPLOYEE_POLICY_ERROR";

export const DELETE_EMPLOYEE_POLICY = "DELETE_EMPLOYEE_POLICY";
export const DELETE_EMPLOYEE_POLICY_SUCCESS = "DELETE_EMPLOYEE_POLICY_SUCCESS";
export const DELETE_EMPLOYEE_POLICY_ERROR = "DELETE_EMPLOYEE_POLICY_ERROR";

export const ADD_HOLIDAY = "ADD_HOLIDAY";
export const ADD_HOLIDAY_SUCCESS = "ADD_HOLIDAY_SUCCESS";
export const ADD_HOLIDAY_ERROR = "ADD_HOLIDAY_ERROR";

export const EDIT_HOLIDAY = "EDIT_HOLIDAY";
export const EDIT_HOLIDAY_SUCCESS = "EDIT_HOLIDAY_SUCCESS";
export const EDIT_HOLIDAY_ERROR = "EDIT_HOLIDAY_ERROR";

export const DELETE_HOLIDAY = "DELETE_HOLIDAY";
export const DELETE_HOLIDAY_SUCCESS = "DELETE_HOLIDAY_SUCCESS";
export const DELETE_HOLIDAY_ERROR = "DELETE_HOLIDAY_ERROR";

export const ADD_REPORT_ALERT = "ADD_REPORT_ALERT";
export const ADD_REPORT_ALERT_SUCCESS = "ADD_REPORT_ALERT_SUCCESS";
export const ADD_REPORT_ALERT_ERROR = "ADD_REPORT_ALERT_ERROR";

export const EDIT_REPORT_ALERT = "EDIT_REPORT_ALERT";
export const EDIT_REPORT_ALERT_SUCCESS = "EDIT_REPORT_ALERT_SUCCESS";
export const EDIT_REPORT_ALERT_ERROR = "EDIT_REPORT_ALERT_ERROR";

export const DELETE_REPORT_ALERT = "DELETE_REPORT_ALERT";
export const DELETE_REPORT_ALERT_SUCCESS = "DELETE_REPORT_ALERT_SUCCESS";
export const DELETE_REPORT_ALERT_ERROR = "DELETE_REPORT_ALERT_ERROR";

export const FACILITY_ACTION_ERROR = "FACILITY_ACTION_ERROR";

export const ADD_COMPLIANCE_ALERT = "ADD_COMPLIANCE_ALERT";

export const ADD_FACILITY_ALERT = "ADD_FACILITY_ALERT";
